import { Card } from '@mui/material';
import { ReactNode } from 'react';
import { ErrorInline } from '../../errors/error-inline/error-inline.component';
import { TimelineRows } from '../timeline-rows/timeline-rows.component';
import { TimelineEventProps } from '../timeline.types';
import { useTimelineCardStyles } from './timeline-card.styles';

export function TimelineCard({
  children,
  isLoading,
  isError,
  events,
  title
}: {
  children?: ReactNode;
  isLoading: boolean;
  isError: boolean;
  events?: TimelineEventProps[];
  title?: string;
}) {
  const classes = useTimelineCardStyles();
  return (
    <Card elevation={0} className={classes.card}>
      {isError ? (
        <ErrorInline
          open={true}
          error={{
            title: 'Something went wrong',
            message: `Sorry, we encountered a problem getting the timeline. Please refresh or go back and try again`
          }}
        />
      ) : (
        <>
          {title ? <p className={classes.title}>{title}</p> : null}
          {events ? <TimelineRows isLoading={isLoading} events={events} /> : null}
          {children}
        </>
      )}
    </Card>
  );
}
